// Actions
export const REGISTER_USER_SETTING = 'REGISTER_USER_SETTING';

export const registerUserSetting = (key, value) => ({
    type: REGISTER_USER_SETTING,
    key,
    value
});